import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule, InputsModule } from '@xref/xref-lib';
import { QRCodeComponent } from 'angularx-qrcode';
import { LoaderModule } from '../loader/loader.module';
import { AuthenticatorModalComponent } from './authenticator-modal.component';

@NgModule({
  declarations: [AuthenticatorModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    InputsModule,
    LoaderModule,
    QRCodeComponent
  ],
  exports: [AuthenticatorModalComponent]
})
export class AuthenticatorModalModule {}
